import { FC, type ReactNode } from "react";
import styled from "@emotion/styled";
import { ParcelSectionGateContext } from "./parcelSectionGateContext";

const GateRoot = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
`;

const GateInner = styled.div<{ $enabled: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  opacity: ${(p) => (p.$enabled ? 1 : 0.55)};
  pointer-events: ${(p) => (p.$enabled ? "auto" : "none")};
  user-select: ${(p) => (p.$enabled ? "auto" : "none")};

  & > * {
    flex: 1;
    min-height: 100%;
  }
`;

type ParcelFormSectionGateProps = {
  enabled: boolean;
  lockHint?: string;
  children: ReactNode;
};

/** ปิดการโต้ตอบส่วนที่ยังไม่ถึงลำดับ — ข้อความล็อกแสดงในการ์ด */
const ParcelFormSectionGate: FC<ParcelFormSectionGateProps> = ({
  enabled,
  lockHint,
  children,
}) => (
  <ParcelSectionGateContext.Provider value={{ enabled, lockHint }}>
    <GateRoot>
      <GateInner $enabled={enabled}>{children}</GateInner>
    </GateRoot>
  </ParcelSectionGateContext.Provider>
);

export default ParcelFormSectionGate;
